<template>
  <div :class="$style.container">
    <ParagraphBody
      :class="$style.name"
      :hasMargin="false"
      :title="webAuthnKey.name"
    >
      {{ webAuthnKey.name || "--" }}
    </ParagraphBody>
    <ButtonEdit
      v-if="shouldAllowEdit"
      aria-label="Open Editor"
      @click="handleStartEdit"
    />
    <EditableNameModal
      headerText="Rename Key"
      :initialName="webAuthnKey.name"
      :isEditing="isEditing"
      @close="handleClose"
      @save="handleSave"
    />
  </div>
</template>

<script>
import { ButtonEdit, ParagraphBody } from '@jumpcloud/ui-components';
import { mapActions } from 'vuex';
import EditableNameModal from 'client/systemusers/UserDetails/WebAuthnKeys/EditableNameModal.vue';

export default {
  name: 'EditableName',

  components: {
    ButtonEdit,
    EditableNameModal,
    ParagraphBody,
  },

  props: {
    webAuthnKey: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isEditing: false,
    };
  },

  computed: {
    shouldAllowEdit() {
      return this.webAuthnKey.attachment !== 'platform';
    },
  },

  methods: {
    ...mapActions('SystemUserWebAuthnKeysModel', [
      'updateWebAuthnKey',
    ]),

    handleClose() {
      this.isEditing = false;
    },

    handleSave(nameValue) {
      this.updateWebAuthnKey({
        webAuthnKey: this.webAuthnKey,
        key: 'name',
        value: nameValue,
      });
    },

    handleStartEdit() {
      this.isEditing = true;
    },
  },
};
</script>
<style module>
.container {
  display: grid;
  grid-template-columns: 1fr auto;
}

.name.name.name {
  margin: auto 0;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
